module.exports = __webpack_public_path__ + "media/images/static/data/DATA-61dcd76e06aed923b7d81212339111d2.png";